<div class="{{ appS.system }} form-nav-case">
  <header class=" ">
    <div class="circle-1 circle-bg start-circle"></div>
    <div class="circle-2 circle-bg end-circle"></div>

    <div class="align-items-center justify-content-between m-0 row">
      <div class="col-md-1 col-2 action-button d-flex gap-3 align-items-center">
        <a (click)="goBack()" class="arrow pointer">
          <fa-icon [icon]="faArrowAltCircleLeft" size="3x"></fa-icon>
        </a>
        @if (!isModal()) {
          <button class="text-light btn h-auto" (click)="appS.showVerticalMenu.set(!appS.showVerticalMenu())">
            @if (appS.showVerticalMenu()) {
              <i class="fa fa-close" aria-hidden="true"></i>
            } @else {
              <i class="fa fa-bars" aria-hidden="true"></i>
            }
          </button>
          <app-navbar-search />
        }
      </div>
      <div class="col-md-9 col-7 center page-title">
        {{ title() || appS.pageNameSignal() | appTranslate | async }}
      </div>
      <div class="col-md-1 col-2 action-button text-end d-flex justify-content-end">
        @if (!isModal()) {
          <a
            class="arrow pointer"
            routerLink="/{{
              this.appS?.getCurrentSystemMetadata?.rootPath || this.appS?.getFirstAvailableSystem?.rootPath
            }}">
            <fa-icon [icon]="faHome" size="3x"></fa-icon>
          </a>
        }
      </div>
    </div>
  </header>
</div>
